import React, { useEffect, useState } from "react";
import PredictionBoxDrop from "./PredictionBoxDrop";
import PredictionBoxInput from "./PredictionBoxInput";
import PredictionBoxRadio from "./PredictionBoxRadio";
import PreviousDayPerfomance from "../../previousDayPrediction/perfomance/PreviousDayPerfomance";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";
import SponsorSlider from "../../sponsorSlider/SponsorSlider";

import ProgressBar from "react-bootstrap/ProgressBar";

import ShareAlt from "../../../assets/img/share-alt.png";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PredictionBoxCurrent = (prop) => {
  const [index, setIndex] = useState(prop.index);

  useEffect(() => {
    getQuestionType();
  }, []);
  useEffect(() => {
    getQuestionType();
  }, [prop.question]);

  function getQuestionType() {
    if (
      prop.question.user_prediction &&
      prop.question.user_prediction.result_updated
    ) {
      return (
        <div className="previousDayPerfomance-bottomSection">
          {" "}
          {prop.question.user_prediction.result != 0 ? (
            <div className="previousDayPerfomance-bottom-wrapper">
              <div className="previousDayPerfomance-bottom-part1">
                <h6 className="points">
                  +{prop.question.user_prediction.score}
                </h6>
                <div className="question-wrapper">
                  <p className="question">
                    {localStorage.language == "en"
                      ? prop.question.question
                      : prop.question.que_malayalam}
                  </p>
                  <p className="answer">
                    {prop.question.user_prediction.result
                      ? localStorage.language == "en"
                        ? "Your prediction " +
                          prop.question.user_prediction.answer +
                          " was correct"
                        : "താങ്കളുടെ പ്രവചനം " +
                          prop.question.user_prediction.answer +
                          " ശരിയാണ്."
                      : localStorage.language == "en"
                        ? "Your prediction " +
                          prop.question.user_prediction.answer +
                          " was wrong"
                        : "താങ്കളുടെ പ്രവചനം " +
                          prop.question.user_prediction.answer +
                          " തെറ്റായിരുന്നു."}
                  </p>


                  <div className="progress-share-wrapper">
                    <div className="progress-bar-wrapper">
                      <p className="progress-bar-top-text">
                        {prop.question.right_percent}% predicted the right
                        answer {prop.question.que_answer}
                      </p>
                      <ProgressBar now={prop.question.right_percent} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="previousDayPerfomance-bottom-part2">
              <h6 className="points">+{prop.question.user_prediction.score}</h6>
              <div className="question-wrapper">
                <p className="question">
                  {localStorage.language == "en"
                    ? prop.question.question
                    : prop.question.que_malayalam}
                </p>
                <p className="answer">
                  {prop.question.user_prediction.result
                    ? localStorage.language == "en"
                      ? "Your prediction " +
                        prop.question.user_prediction.answer +
                        " was correct"
                      : "താങ്കളുടെ പ്രവചനം" +
                        prop.question.user_prediction.answer +
                        "ശരിയാണ്."
                    : localStorage.language == "en"
                      ? "Your prediction " +
                        prop.question.user_prediction.answer +
                        " was wrong"
                      : "താങ്കളുടെ പ്രവചനം " +
                        prop.question.user_prediction.answer +
                        " തെറ്റായിരുന്നു."}
                </p>

                <div className="progress-bar-wrapper">
                  <p className="progress-bar-top-text">
                    {prop.question.right_percent}% predicted the right answer{" "}
                    {prop.question.que_answer}
                  </p>
                  <ProgressBar now={prop.question.right_percent} />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      if (prop.question.que_type == 1) {
        return (
          <PredictionBoxRadio
            data={prop.question}
            index={index}
            updateAnswers={prop.updateAnswers}
            isPostponed={prop.isPostponed}
          />
        );
      } else if (prop.question.que_type == 2) {
        return (
          <PredictionBoxDrop
            data={prop.question}
            index={index}
            updateAnswers={prop.updateAnswers}
            isPostponed={prop.isPostponed}
          />
        );
      } else if (prop.question.que_type == 3) {
        return (
          <PredictionBoxInput
            data={prop.question}
            type={1}
            index={index}
            updateAnswers={prop.updateAnswers}
            isPostponed={prop.isPostponed}
          />
        );
      } else if (prop.question.que_type == 4) {
        return (
          <PredictionBoxInput
            data={prop.question}
            type={2}
            index={index}
            updateAnswers={prop.updateAnswers}
            isPostponed={prop.isPostponed}
          />
        );
      }
    }
  }

  return <div>{getQuestionType()}</div>;
};

export default PredictionBoxCurrent;
